import React, { useEffect, ReactNode } from 'react'
import { useForm, FormProvider, UseFormReturn, FieldValues } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { registerForm, unregisterForm } from '../../utils/single-step-form-orchestrator'

interface DonationOptionFormWrapperProps<T extends FieldValues> {
  formName: string
  errorMessage: string
  validationSchema: any
  useInitialValues: () => T
  children: (form: UseFormReturn<T>) => ReactNode
}

const DonationOptionFormWrapper = <T extends FieldValues>({
  formName,
  errorMessage,
  validationSchema,
  useInitialValues,
  children,
}: DonationOptionFormWrapperProps<T>) => {
  const initialValues = useInitialValues()

  // Initialize and set up validation
  const form = useForm<T>({
    values: initialValues,
    resolver: yupResolver(validationSchema),
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })

  // register/unregister form
  useEffect(() => {
    registerForm({
      name: formName,
      formRef: form,
      errorMessage,
    })

    return () => unregisterForm({ name: formName })
  }, [form, formName, errorMessage])

  return (
    <FormProvider {...form}>
      <form>{children(form)}</form>
    </FormProvider>
  )
}

export default DonationOptionFormWrapper
